/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

export interface CardListHeadingStyles {
    TitleText: InjectableCss;
}

export const cardListHeadingStyles: CardListHeadingStyles = {
    TitleText: {
        css: css`
            font-size: 24px;
            font-weight: 400;
            font-style: normal;
            line-height: normal;
            h2 {
                margin-bottom: 31px !important;
            }
         ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`font-size: 16px !important;  `,
                css`font-size: 16px !important; `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
};

const styles = cardListHeadingStyles;
const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem
            width={12}
            css={css`
                padding: 0;
            `}
        >
            <GridContainer
                gap={0}
                offsetCss={css`
                    /* border-bottom: 1px solid ${getColor("common.border")}; */
                    padding-top: 40px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css` `,
                            css`
                                padding-left: 20px;
                                padding-right: 20px;
                            `,
                            css` `,
                            css` `,
                            css``,
                        ])}
                    &&& {
                        width: 100%;
                    }
                `}
            >
                <GridItem width={8}>
                    <Typography {...styles.TitleText} className="card-list-heading" variant="h2">
                        {heading}
                    </Typography>
                </GridItem>
                {viewAllUrl && (
                    <GridItem width={4}>
                        <Link
                            href={viewAllUrl}
                            icon={{ iconProps: { src: ChevronRight } }}
                            typographyProps={{ size: 15 }}
                            css={css`
                                margin-left: auto;
                                margin-top: 5px;
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`font-size: 16px !important; 
                                             margin-top: -2px; `,
                                        css`font-size: 16px !important;
                                             margin-top: -2px; `,
                                        css``,
                                        css``,
                                        css``,
                                    ])}
                            `}
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                            <VisuallyHidden>
                                {translate("View All")} {heading}
                            </VisuallyHidden>
                        </Link>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
